import { ReactNode } from 'react';
import SidePanel from 'components/sidePanel/SidePanel';
import { channelsTabSidePanelId } from './ChannelsTabs.constants';
import { ChannelsTabsHeaderContainer } from './ChannelsTabsHeader.styles';

const ChannelsTabsHeader = ({
  sidePanelContent,
}: {
  sidePanelContent: ReactNode;
}) => {
  return (
    <ChannelsTabsHeaderContainer>
      {sidePanelContent && (
        <SidePanel sidePanelId={channelsTabSidePanelId}>
          {sidePanelContent}
        </SidePanel>
      )}
    </ChannelsTabsHeaderContainer>
  );
};

export default ChannelsTabsHeader;
